import { Modal as MantineModal } from "@mantine/core";
import type { CustomModalTitleFactory, IProps } from "./modal-title.types";
import { componentWrapper } from "../../../utilities";
import { isValidElement } from "react";
import { Title } from "../../title";

const ModalTitle = componentWrapper<CustomModalTitleFactory, IProps>(
    "ModalTitle",
    ({ children, ...otherProps }, ref) => {
        return (
            <MantineModal.Title ref={ref} {...otherProps}>
                {typeof children === "string" ? (
                    <Title order={4} component="span">
                        {children}
                    </Title>
                ) : isValidElement(children) ? (
                    children
                ) : undefined}
            </MantineModal.Title>
        );
    }
);

export { ModalTitle };
